function transformImageSpecifications(data) {
    // 将 key 和 value 连接成字符串数组
    const keyValuePairs = Object.entries(data).map(([key, value]) => `${key} ${value}`);

    // 每 3 个元素生成一个对象，不足的部分用空字符串填充
    const result = [];
    for (let i = 0; i < keyValuePairs.length; i += 3) {
        const chunk = keyValuePairs.slice(i, i + 3);

        while (chunk.length < 3) {
            chunk.push('');
        }

        result.push({
            key: (i / 3 + 1).toString(), // 生成唯一的 key
            name: chunk[0],
            age: chunk[1],
            address: chunk[2],
        });
    }

    return result;
}


export {
    transformImageSpecifications,
}
